import styled from "styled-components";
import { themeSizes } from "theme";

const Container = styled("div")`
  display: flex;
  align-items: center;
`;

const paddingOffest = ({ $size }) => {
  switch ($size) {
    case themeSizes.xs:
      return 4;
    case themeSizes.sm:
      return 8;
    case themeSizes.md:
    default:
      return 12;
  }
};

const ElementContainer = styled("div")`
  width: 0px;
  & * {
    transform: translateX(-100%) translateX(-${paddingOffest}px);
  }
`;

const TranslateIn = { Container, ElementContainer };
export default TranslateIn;
